import React, { useState , useRef} from 'react';
import 'primereact/resources/themes/lara-light-indigo/theme.css';
import 'primeicons/primeicons.css';
import formlabels from './data/formlabels.json'
import { Form, Field } from 'react-final-form';

import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import { Stepper } from 'primereact/stepper';
import { StepperPanel } from 'primereact/stepperpanel';
import { classNames } from 'primereact/utils';
import { TabView, TabPanel } from 'primereact/tabview';
import { InputSwitch } from 'primereact/inputswitch';

import HomeAddress from './front modules/HomeAddress';
import PersonalIdentity from './front modules/PersonalIdentity';
import Busline from './front modules/Busline';
import Authority from './front modules/Authority';
import Chapitre from './front modules/Chapitre';
import Summary from './front modules/Summary';

import 'primeflex/primeflex.css';

import ReCAPTCHA from "react-google-recaptcha";

// import data from './data/data.json';
// const busLines = data.buslines;
// const chapitres = data.chapitres;

const fetchDataSync = () => {
  const xhr = new XMLHttpRequest();
  xhr.open('GET', 'https://chartrespilgerverein.ch/backend/form_data.php', false); // false pour requête synchrone
  try {
    xhr.send();
    if (xhr.status === 200) {
      const data = JSON.parse(xhr.responseText);
      return data.data;
    } else {
      throw new Error(`HTTP error! status: ${xhr.status}`);
    }
  } catch (error) {
    console.error('Error fetching JSON data:', error);
    return null;
  }
};

let busLines = [];
let chapitres = [];

const data = fetchDataSync();
if (data) {
  busLines = data.buslines;
  chapitres = data.chapitres;
}

const calculateAge = (birthDate) => {
  const today = new Date();
  const birth = new Date(birthDate);
  let age = today.getFullYear() - birth.getFullYear();
  const m = today.getMonth() - birth.getMonth();
  if (m < 0 || (m === 0 && today.getDate() < birth.getDate())) {
    age--;
  }
  return age;
};
function getBusLineData(buslineName) {
  return busLines.find((line, index) => line.name === buslineName);
}
function getChapitreData(chapitreName) {
  return chapitres.find((chapitre, index) => chapitre.name === chapitreName);
}
const isFormFieldValid = (meta) => !!(meta.touched && meta.error);
const getFormErrorMessage = (meta) => {
  return isFormFieldValid(meta) ? <small className="p-error">{meta.error}</small> : <small>&nbsp;</small>;
};
function getPrices(buslineName, birthDate) {
  const busline = getBusLineData(buslineName);
  const person_age = calculateAge(birthDate);
  const ages = busline.prices.map(price => parseInt(price.AgeMax));
  const selectedages = ages.filter(age => age >= person_age);
  const lowestagemax = Math.min(
    ...selectedages
  );
  return busline.prices.find(price => parseInt(price.AgeMax) === lowestagemax) || {
    "PriceOneWay": '???',
    "PriceRoundTrip": '???',
    "PriceNoTrip": '???'
  };
}
function exactPrice(member) {
  if (member.currentStep < 4) {
    return { 'currency': '€', 'price': 0, 'memberName': "???(" + (member.surname || '') + " " + (member.name || '') + ")" };
  }
  const currency = (member.takesPart || member.personID > 0) ?
    (getBusLineData((member.takesBus) ? member.busLine : member.chapitreRegion).currency) :
    (member.address_country === "CH" ? "CHF" : "€");
  const price = (member.takesPart || member.personID > 0) ?
    (member.takesBus ?
      parseInt(getPrices(member.busLine, member.birthDate)[(member.tripType === 'roundtrip') ? 'PriceRoundTrip' : 'PriceOneWay']) :
      (calculateAge(member.birthDate) < 18 ? 9 : 42)
    ) : 0;
  const memberName = member.name + " " + member.surname + "(" + (member.birthDate ? calculateAge(member.birthDate) : "") + ")";
  return { currency, price, memberName };
}
//TODO: generally, would be better to switch to a typed version. Maybe use typescript?
//TODO: move this out into another file and import it here
const renderFamilyMemberForm = (index, sfd, fd, familyMember, labelslanguage, jumptolasttab, addFamilyMember) => {
  const labels = formlabels[labelslanguage];
  familyMember.currentStep = familyMember.currentStep || 0;
  return (
    <TabPanel key={familyMember.personID}
      header={familyMember.name || ("user " + familyMember.personID)}
      closable={familyMember.personID > 0}
      leftIcon={"pi mr-2 pi-user" + ((familyMember.currentStep == 4) ? "" : "-edit")}>
      <Stepper linear={true} orientation="vertical" activeStep={familyMember.currentStep} >
        <StepperPanel header={labels.identity} key="identity">
          <PersonalIdentity familyMember={familyMember} sfd={sfd} labels={labels} calculateAge={calculateAge} isFormFieldValid={isFormFieldValid} getFormErrorMessage={getFormErrorMessage} />
        </StepperPanel>
        <StepperPanel header={labels.legalDetails} key="legal">
          {(familyMember.personID > 0) ?
            <Authority familyMember={familyMember} sfd={sfd} fd={fd} labels={labels} isFormFieldValid={isFormFieldValid} getFormErrorMessage={getFormErrorMessage} calculateAge={calculateAge} /> :
            <HomeAddress familyMember={familyMember} sfd={sfd} fd={fd} labels={labels} isFormFieldValid={isFormFieldValid} getFormErrorMessage={getFormErrorMessage} />
          }
        </StepperPanel>
        <StepperPanel header={labels.busLine} key="busline">
          <Busline familyMember={familyMember} sfd={sfd} labels={labels} busLines={busLines} isFormFieldValid={isFormFieldValid} getFormErrorMessage={getFormErrorMessage} getBusLineData={getBusLineData} getPrices={getPrices} />
        </StepperPanel>
        <StepperPanel header={labels.chapitre} key="chapitre">
          <Chapitre familyMember={familyMember} sfd={sfd} labels={labels} labelslanguage={labelslanguage} busLines={busLines} chapitres={chapitres} getChapitreData={getChapitreData} isFormFieldValid={isFormFieldValid} getFormErrorMessage={getFormErrorMessage} />
        </StepperPanel>
        <StepperPanel header={labels.summary} key="summary">
          <Summary familyMember={familyMember} labels={labels} sfd={sfd} jumptolasttab={jumptolasttab} exactPrice={exactPrice} addmember={() => addFamilyMember()} />

        </StepperPanel>
      </Stepper>
    </TabPanel >
  );
};

const RegisterForm = () => {
  let params = new URLSearchParams(window.location.search);
  let lang = params.get('lang');
  lang = (lang !== null && formlabels.hasOwnProperty(lang)) ? lang : 'en';
  const [formData, setFormData] = useState([{ personID: 0, currentStep: 0, takesPart: true }]);
  const [recaptchaValidated, setRecaptchaValidated] = useState(false);
  const [recaptchaToken, setRecaptchaToken] = useState(null);
  const [labelslanguage, _setLabelsLanguage] = useState(lang);
  const [submitted, setSubmitted] = useState(false);
  const [tabcount, setTabCount] = useState(1);
  const [activeIndex, setActiveIndex] = useState(0);
  const setLabelsLanguage = (l) => {
    if (l !== null && formlabels.hasOwnProperty(l)) {
      _setLabelsLanguage(l)
    }
  }
  const handleSubmit = async (e) => {
    if (!recaptchaToken) {
      alert("Please complete the CAPTCHA before submitting.");
      return;
    }
    const formDataWithCaptcha = {
      ...formData
    };
    formDataWithCaptcha[0].recaptcha = recaptchaToken;
    formDataWithCaptcha[0].maillanguage = labelslanguage;
    console.log("Form Data Sent:", formDataWithCaptcha);

    try {
      const response = await fetch('https://chartrespilgerverein.ch/backend/register.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formDataWithCaptcha),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const result = await response.json();

      if (result.status === 'OK') {
        console.log('Form Data Submitted Successfully:', result);
        setSubmitted(true);
      } else {
        console.error('Error from backend:', result.message);
        alert(`Error: ${result.message}`);
      }
    } catch (error) {
      console.error('Submission error:', error);
      alert('An error occurred while submitting the form. Please try again.');
    }
  };
  const addFamilyMemberButton = useRef(null);
  return (
    <div className="container">
      {submitted ? (
        <div>
          <h3>Registration Successful!</h3>
          <p>Thank you for registering, {formData[0].name} {formData[0].surname}.</p>
        </div>
      ) : (<>
        <div className="flex justify-content-between flex-wrap">
          <Button type="button"
            icon="mr-2 pi pi-user-plus"
            ref={addFamilyMemberButton}
            severity='secondary'
            onClick={() => {
              setFormData([...formData, { personID: tabcount, currentStep: 0
               }]);
              setTabCount(tabcount + 1);
            }}>
            {formlabels[labelslanguage].addFamilyMember}
          </Button>          <Dropdown
            value={labelslanguage}
            options={Object.keys(formlabels).map((lang) => ({ label: formlabels[lang].emoji + " " + lang.toUpperCase(), value: lang }))}
            onChange={(e) => setLabelsLanguage(e.value)}
          />
        </div>
        <div>
          <TabView
            activeIndex={activeIndex}
            onTabClose={(e) => {
              const updatedFormData = [...formData].filter((p, i) => i !== e.index);
              if (updatedFormData.filter((member) => member.isSpouse === false).length === 1 && !updatedFormData[0].takesPart && updatedFormData[0].currentStep === 4)
                updatedFormData[0].currentStep = 1;
              setFormData(updatedFormData);
              setActiveIndex((prevIndex) => Math.min(prevIndex, updatedFormData.length - 1));
            }}
            style={{ width: "100%" }}
            scrollable={true}
            onTabChange={(e) => setActiveIndex(e.index)}
          >
            {[...formData.map((_, index) =>
              renderFamilyMemberForm(index,
                (a) => {
                  const updatedFormData = [...formData]; // Create a new array
                  updatedFormData[index] = a;
                  setFormData(updatedFormData);
                },
                formData,
                formData[index], labelslanguage,
                (e) => { setActiveIndex(tabcount); },
                () => { addFamilyMemberButton.current.click() })), (

              <TabPanel key={"submissionpanel"} header={formlabels[labelslanguage].submission} closable={false} leftIcon={"pi mr-2 pi-send"}>
                <Form
                  validate={(data) => {
                    if (!data.IAgree)
                      return { IAgree: formlabels[labelslanguage]['This field is required.'] };
                    return {};
                  }}
                  onSubmit={(e) => {
                    console.log(formData);
                    if (formData.some(member => member.currentStep < 4))
                      setActiveIndex(formData.findIndex(member => member.currentStep < 4));
                    else {
                      if (!recaptchaValidated)
                        alert("Please complete the CAPTCHA before submitting.");
                      else
                        handleSubmit(e);
                    }

                  }}
                  initialValues={{ IAgree: false }}
                  render={({ handleSubmit }) => {
                    return <>
                      <div className="flex align-items-center justify-content-center py-3 border-round-md mt-3 flex-column">
                        <table className="col-12 md:col-6">
                          {
                            Object.entries(formData.map(exactPrice)
                              .reduce((acc, { currency, price, memberName }) => {
                                if (!acc[currency]) {
                                  acc[currency] = { sum: 0, members: [] };
                                }
                                acc[currency].sum += parseFloat(price);
                                acc[currency].members.push({ n: memberName, p: price });
                                return acc;
                              }, {})).map(([currency, { sum, members }]) => (
                                <>
                                  {members.map(({ n, p }, i) => <tr key={i}><td>{n}</td> <td>{p}</td> </tr>)}
                                  <tr className="total"><td>Total {currency}</td><td>{sum}</td></tr>
                                </>

                              ))

                          }
                        </table>
                        <div className="flex flex-column justify-content-center align-items-start">
                          <div
                            className="p-text-center"
                            dangerouslySetInnerHTML={{ __html: formlabels[labelslanguage].cancellationPolicy }}
                          ></div>
                          <Field name={"IAgree"} type="checkbox" render={({ input, meta }) => (<>
                            <div className="field flex align-items-center flex-row justify-content-start">
                              <label className={classNames({ 'p-error': isFormFieldValid(meta) })}
                                style={{ marginBottom: 0 }}>{formlabels[labelslanguage].IAgree}&nbsp;</label>
                              <InputSwitch {...input}
                                className={classNames({ 'p-error': isFormFieldValid(meta) })} />
                            </div>
                            {getFormErrorMessage(meta)}
                          </>
                          )} />
                        </div>
                      </div>
                      <ReCAPTCHA
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                        }}
                        sitekey="6Ldd_cQqAAAAAFiaKPLIO3tm9uQBLOFFmazVeSVi"
                        onChange={(token) => {
                          if (token) {
                            setRecaptchaToken(token);
                            setRecaptchaValidated(true);
                            console.log("Captcha validated successfully:", token);
                          } else {
                            setRecaptchaValidated(false);
                            setRecaptchaToken(null);
                            console.log("Captcha validation failed.");
                          }
                        }}
                      />
                      <div className="flex justify-content-center align-items-center mt-5">
                        <Button
                          type="submit"
                          onClick={(e) => {
                            console.log(formData)
                            e.preventDefault();
                            handleSubmit(e);
                          }}
                        >
                          {formlabels[labelslanguage].submit}
                        </Button>
                      </div>
                    </>;
                  }} />
              </TabPanel>
            )]}
          </TabView>
        </div>
      </>)}
    </div >
  );
};

export default RegisterForm;
